import { render } from "./history_admin.vue?vue&type=template&id=def99de8&scoped=true"
import script from "./history_admin.vue?vue&type=script&lang=js"
export * from "./history_admin.vue?vue&type=script&lang=js"

import "./history_admin.vue?vue&type=style&index=0&id=def99de8&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def99de8"]])

export default __exports__